import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles(() => ({
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'var(--brand-base-0)',
        width: '100%',
        marginBottom: '1rem',
        borderRadius: '10px',
        border: '1px solid var(--brand-primary)',
        padding: '16px',
        '&:hover:not($active)': {
            background: 'var(--feature-1-30)'
        },
        '&:hover': {
            cursor: 'pointer'
        }
    },
    originalPadding: {
        padding: '1rem'
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        '& p': {
            marginBottom: '0px'
        }
    },
    spacing: {
        width: '100%',
        flexWrap: 'wrap',
        justifyContent: 'space-between'
    },
    wrap: {
        width: '100%',
        flexWrap: 'wrap'
    },
    description: {
        color: 'var(--brand-primary)',
        fontWeight: '600',
        textAlign: 'left'
    },
    title: (isXS) => ({
        fontSize: isXS ? '16px' : '18px',
        marginRight: '5px'
    }),
    subtext: {
        fontSize: '12px',
        marginBottom: '0px'
    },
    divider: {
        marginLeft: '5px',
        marginRight: '5px'
    },
    column: {
        display: 'flex',
        flexDirection: 'column'
    },
    fixedWidth: {
        width: '35%'
    },
    rightColumnWidth: {
        width: '60%'
    },
    unset: {
        color: 'unset',
        width: '100%'
    },
    active: {
        color: '#ffffff',
        background: 'var(--feature-1)',
        borderColor: 'var(--color-border-default)',
        '& p': {
            color: '#ffffff'
        }
    },
    contentWrapper: {
        flexWrap: 'wrap',
        justifyContent: 'start'
    },
    label: {
        marginRight: '0.5rem'
    },
    originalLabel: {
        fontSize: '1.2rem',
        fontWeight: 'normal'
    },
    originalTitle: {
        fontWeight: '600',
        fontSize: '1.6rem'
    },
    hide: {
        display: 'none'
    },
    removeMargin: {
        marginBottom: '0rem'
    },
    xsMarginBottom: {
        marginBottom: '1rem'
    },
    justifyText: {
        textAlign: 'left'
    },
    additionalMargin: {
        marginBottom: '3.2rem'
    },
    seriesFont: {
        fontSize: '16px'
    }
}));
